export abstract class UIAdController {
    abstract showLobbyVerticalAds()
    abstract removeLobbyAds()
    abstract showInGameAds()
    abstract hideInGameAds()
}
